import { render, staticRenderFns } from "./ProfileTenantsTable.vue?vue&type=template&id=11846849&scoped=true&"
import script from "./ProfileTenantsTable.vue?vue&type=script&lang=js&"
export * from "./ProfileTenantsTable.vue?vue&type=script&lang=js&"
import style0 from "./ProfileTenantsTable.vue?vue&type=style&index=0&id=11846849&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11846849",
  null
  
)

export default component.exports